import { ExternalLink } from "lucide-react";

interface TestimonialProps {
  quote: string;
  author: string;
  link?: string;
  linkText?: string;
  trustBadge?: React.ReactNode;
  className?: string;
}

const Testimonial = ({ quote, author, link, linkText, trustBadge, className = '' }: TestimonialProps) => {
  return (
    <section className={`py-16 px-8 ${className}`}>
      {trustBadge && <div className="max-w-4xl mx-auto text-center mb-6">{trustBadge}</div>}
      <div className="max-w-4xl mx-auto text-center">
        <blockquote className="space-y-6">
          <p className="text-xl md:text-2xl font-serif italic text-foreground leading-relaxed">
            "{quote}"
          </p>
          <footer className="text-muted-foreground space-y-2">
            {link ? (
              <a
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary hover:text-primary-glow transition-colors inline-flex items-center gap-1"
              >
                —{author}
                <ExternalLink className="w-4 h-4" />
              </a>
            ) : (
              <cite className="not-italic block">—{author}</cite>
            )}
          </footer>
        </blockquote>
      </div>
    </section>
  );
};

export default Testimonial;
